import { render, staticRenderFns } from "./Parzellen.vue?vue&type=template&id=2c10eb6c&"
import script from "./Parzellen.vue?vue&type=script&lang=js&"
export * from "./Parzellen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports